import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative p-1.5 rounded-lg transition-all duration-300 group overflow-hidden ${
        isDark
          ? 'bg-gradient-to-br from-yellow-500/10 to-orange-500/10 backdrop-blur-md border border-yellow-500/20 hover:border-yellow-500/40 hover:shadow-lg hover:shadow-yellow-500/20'
          : 'bg-gradient-to-br from-indigo-500/10 to-purple-500/10 backdrop-blur-md border border-indigo-500/20 hover:border-indigo-500/40 hover:shadow-lg hover:shadow-indigo-500/20'
      }`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {/* Animated background gradient */}
      <div className={`absolute inset-0 bg-gradient-to-r ${
        isDark ? 'from-yellow-500/5 to-orange-500/5' : 'from-indigo-500/5 to-purple-500/5'
      } opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>

      {/* Icon */}
      <div className="relative">
        {isDark ? (
          <Sun size={15} className={`text-yellow-400 transition-all duration-300 group-hover:rotate-90`} />
        ) : (
          <Moon size={15} className={`text-indigo-400 transition-all duration-300 group-hover:-rotate-12`} />
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;
